var _g, _g2, _path, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnitLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 2000,
    height: 727,
    viewBox: "0 0 2000 727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.2120933201755406,-0.4095151251643756)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 144",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 727,
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.23999447739475954,0.08111441268729891)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 143.83777117462537",
    height: 143.83777117462537,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 809.557144593677 294.40962610449134",
    height: 143.83777117462537,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 12.807604395965829,
    height: 142.73115013748853,
    x: 429.0477601988634,
    y: 75.8392379835014,
    fill: "#f8f8f8",
    opacity: 1,
    strokeWidth: 0,
    stroke: "transparent",
    fillOpacity: 1,
    className: "rect-o-0",
    "data-fill-palette-color": "primary",
    rx: "1%",
    id: "o-0",
    "data-palette-color": "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,76.19429059578371)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 142.0210449129239",
    height: 142.0210449129239,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 142.0210449129239",
    height: 142.0210449129239,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 142.0210449129239",
    height: 142.0210449129239,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "3.319999933242798 -37.77000045776367 106.54000091552734 38.26000213623047",
    height: 142.0210449129239,
    "data-palette-color": "#f8f8f8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.63-3.81L21.63-3.81Q24.27-3.81 26.42-4.91 28.56-6.01 30.09-7.9 31.62-9.79 32.45-12.33 33.28-14.87 33.28-17.75L33.28-17.75Q33.28-20.8 32.36-23.4 31.45-26 29.83-27.91 28.22-29.81 26.03-30.88 23.83-31.96 21.26-31.96L21.26-31.96Q18.6-31.96 16.46-30.83 14.31-29.71 12.79-27.8 11.28-25.88 10.46-23.34 9.64-20.8 9.64-17.94L9.64-17.94Q9.64-14.89 10.55-12.3 11.45-9.72 13.05-7.84 14.65-5.96 16.85-4.88 19.04-3.81 21.63-3.81ZM20.8 0.49L20.8 0.49Q18.43 0.49 16.21-0.06 13.99-0.61 12.05-1.65 10.11-2.69 8.51-4.2 6.91-5.71 5.75-7.67 4.59-9.62 3.96-11.98 3.32-14.33 3.32-17.04L3.32-17.04Q3.32-19.85 4-22.36 4.69-24.88 5.92-27 7.15-29.13 8.89-30.85 10.62-32.57 12.71-33.76 14.79-34.96 17.19-35.61 19.58-36.25 22.17-36.25L22.17-36.25Q25.66-36.25 28.82-35.07 31.98-33.89 34.38-31.63 36.77-29.37 38.18-26.12 39.6-22.88 39.6-18.75L39.6-18.75Q39.6-15.97 38.93-13.45 38.26-10.94 37.04-8.8 35.82-6.67 34.11-4.94 32.4-3.22 30.31-2.01 28.22-0.81 25.82-0.16 23.41 0.49 20.8 0.49ZM46.99 0L46.99-25.88 51.78-25.88 52.61-21.46Q53.46-22.24 54.54-23.11 55.61-23.97 56.88-24.69 58.15-25.42 59.56-25.89 60.96-26.37 62.47-26.37L62.47-26.37Q64.26-26.37 65.71-25.7 67.16-25.02 68.19-23.82 69.21-22.61 69.77-20.92 70.33-19.24 70.33-17.24L70.33-17.24 70.33 0 64.4 0 64.4-16.53Q64.4-17.85 64.04-18.85 63.67-19.85 63.02-20.51 62.38-21.17 61.48-21.51 60.59-21.85 59.57-21.85L59.57-21.85Q57.76-21.85 56.15-20.92 54.54-20 52.9-18.48L52.9-18.48 52.9 0 46.99 0ZM78.46 0L78.46-25.88 84.39-25.88 84.39 0 78.46 0ZM81.42-30.98L81.42-30.98Q80.63-30.98 79.99-31.24 79.34-31.49 78.86-31.93 78.39-32.37 78.13-32.98 77.88-33.59 77.88-34.3L77.88-34.3Q77.88-35.03 78.16-35.66 78.44-36.28 78.94-36.76 79.44-37.23 80.11-37.5 80.78-37.77 81.56-37.77L81.56-37.77Q82.32-37.77 82.95-37.5 83.59-37.23 84.05-36.78 84.52-36.33 84.79-35.71 85.05-35.08 85.05-34.38L85.05-34.38Q85.05-33.64 84.77-33.02 84.49-32.4 83.99-31.95 83.49-31.49 82.83-31.24 82.17-30.98 81.42-30.98ZM94.79-7.15L94.79-21.66 89.59-21.66 90.03-24.44Q91.96-24.93 93.12-25.54 94.28-26.15 95.05-27.04 95.82-27.93 96.39-29.21 96.97-30.49 97.72-32.32L97.72-32.32 100.55-32.32 100.55-25.88 109.86-25.88 108.81-21.66 100.72-21.66 100.72-8.33Q100.72-7.13 101.07-6.31 101.41-5.49 102.04-4.98 102.68-4.47 103.57-4.24 104.46-4 105.58-4L105.58-4Q106.66-4 107.72-4.2 108.78-4.39 109.73-4.76L109.73-4.76 109.73-1.78Q108.07-0.66 106.18-0.09 104.29 0.49 102.36 0.49L102.36 0.49Q98.67 0.49 96.73-1.51 94.79-3.52 94.79-7.15L94.79-7.15Z",
    fill: "#f8f8f8",
    "data-fill-palette-color": "primary"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,475.3831247936926,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 334.1740197999843 294.40962610449134",
    height: 294.40962610449134,
    width: 334.1740197999843,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "6.300000190734863 11.5 87.39999389648438 77",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    height: 294.40962610449134,
    width: 334.1740197999843,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3 12.3L72.3 12.3 72.3 12.3l-0.4-0.8H28.2L6.3 50l21.8 38.5h43.7L93.7 50 72.3 12.3zM33.3 25.3L9.9 47.7l18.6-32.8L33.3 25.3zM70.7 14.8l6.4 35.7L36.9 25.8 70.7 14.8zM35.5 27.3l41 25.2-41 23.3V27.3zM77 54.5l-7.2 30.8-32.6-8.1L77 54.5zM33.5 75L9.9 50.5l23.6-22.7V75zM33.2 77.6l-4.6 7.7L11.5 55.1 33.2 77.6zM35 78.6l31.4 7.9H30.2L35 78.6zM79.3 53.3l11.6-2.5L72.1 84 79.3 53.3zM90.7 48.9l-11.4 2.5-5.9-33.1L90.7 48.9zM35 24.3l-5-10.8h38.2L35 24.3z",
    fill: "#f2f2f2",
    "data-fill-palette-color": "accent"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 143.83777117462537,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnitLogo);
export default __webpack_public_path__ + "static/media/onitLogo.f33d30189d279f9e208c47b1058793de.svg";
export { ForwardRef as ReactComponent };